
export const ProjectCostSummaryRouting = [
  {
    path: "/report-center/download/project-cost-summary/list",
    name: "project-cost-summary",
    meta: { title: "项目成本汇总表" },
    component: () =>
      import(
        /* webpackChunkName: "labor-wage" */ "@/views/report-center/project-cost-summary/list/index.vue"
        ),
  },
];
